<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_Committees") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
                    <div class="col-md-4 p-0">
                        <v-label>{{ searchTermlbl }}</v-label>
                        <v-text-field v-model="searchTerm" label="" solo></v-text-field>
                    </div>
                    <div class="col-md-4 p-0 h-100">
                        <div class="d-flex gap-2 h-100 align-items-end">
                            <v-btn color="light-blue" dense @click="clearFilter()">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn color="primary" dense @click="getEntityGroup()">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn color="primary" @click="openCommitteeForm">{{ $t("res_ButtonText_Add") }}</v-btn>
                        </div>
                    </div>
                </div>

                <Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>

				<div class="d-flex flex-1 flex-column overflow-auto mt-2"> 
                    <v-data-table
                        :mobile-breakpoint="0"
                        class="position-relative white flex-1 d-flex overflow-auto elevation-1 CommitteesTable"
                        disable-sort
                        loading-text="loading..."
                        :no-data-text="$t('res_Label_NoData')"
                        :footer-props="{'items-per-page-text': 'Items per page'}"
                        caption=""
                        hide-default-footer
                        header-fixed
                        :class="{'no-data': entityGroupData.length == 0}"
                        :items-per-page="pagingData.pageSize"
                        :headers="headers"
                        :items="entityGroupData"
                        item-key="id">
                        <template v-slot:headers="{headers}">
                            <tr>
                                <th style="background-color: #e7ebef" v-for="header in headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>

                        <template v-slot:item="row">
                            <tr>
                                <td class="w-25 text-center">{{ row.item.baseDetails.name }}</td>
                                <td class="w-25 text-center">{{ row.item.baseDetails.nameAr }}</td>
                                <td class="w-25 text-center">{{ row.item.baseDetails.type == 1 ? $t("res_Label_Internal") : $t("res_Label_External") }}</td>
                                <td class="text-end">
                                    <div style="display: flex; align-items: center; justify-content: flex-end" class="CommitteesActionstd">
                                        <div class="custom-icon-wrapper">
                                            <a @click="showStructureDilog(row.item)" v-tooltip.hover="$t('res_Label_ManageUser-Structure')" class="custom-table-icon">
                                                <span class="mdi mdi-account-outline" style="font-size: 20px"></span>
                                            </a>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('Update')" @click="showEditDialog(row.item)">custom-icon white-bg edit-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="deleteEntityGroup(row.item)">custom-icon white-bg delete-icon</v-icon>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="addStructureUser" max-width="800px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_Label_SelectStructureOrUser") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addStructureUser = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="row mb-3 mt-2">
                        	<div class="col-10">
                            <StructureUserSelector
								id="ManageCommitteeUserStructureSelector"
                                :showInternalUsers="GroupExternal == false"
                                :showExternalUsers="GroupExternal == true"
                                :showInternalStructures="GroupExternal == false"
                                :showExternalStructures="GroupExternal == true"
                                :excludeSelf="false"
                                :selectedStructureUsersList="selectedStructures"
                                @structureUserSelectChanged="updateSelectedStructures"
                                :isMultiple="true">
                            </StructureUserSelector>
                        </div>
                        <div class="col-2 m-auto">
                            <v-btn :disabled="selectedStructures.length == null || selectedStructures.length == 0 || (selectedStructures.length == 1 && (selectedStructures[0].id == null || selectedStructures[0].id == ''))" style="width: 100px" color="primary" variant="text" @click="saveChanges">
                                {{ $t("res_ButtonText_Add") }}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <v-data-table
                                :headers="structures_Users_Headers"
                                :items="structs_users_items"
                                item-key="id"
                                class="elevation-1"
                                id="structuresTable"
                                :mobile-breakpoint="0"
                                disable-sort
                                loading-text="loading..."
                                :no-data-text="$t('res_Label_NoData')"
                                :footer-props="{'items-per-page-text': 'Items per page'}"
                                caption=""
                                hide-default-footer
                                header-fixed>
                                <template v-slot:item="row">
                                    <tr>
                                        <td class="text-center"> 
											  {{ row.item.structureDetails?.isUser ? row.item.structureDetails.userName : row.item?.structureDetails?.structureName }}
                                        </td> 
										<td class="text-center">{{ row.item.structureDetails.isUser ? $t("res_Label_User") : $t("res_Label_Structure") }}</td>
										<td class="text-center" v-if="enableCommitteesChairmanUsers == true">{{ row.item.structureDetails.isChairman ? $t("res_ButtonText_Yes") : row.item.structureDetails.isUser ? $t("res_ButtonText_No") : "" }}</td> 
                                        <td class="text-end">
                                            <div style="display: flex; align-items: center; justify-content: flex-end" class="CommitteesActionstd"> 

											   <div class="custom-icon-wrapper" v-if="enableCommitteesChairmanUsers && row.item.structureDetails.isUser && !row.item.structureDetails.isChairman">
													<a @click="UpdateUserChairman(row.item.structureDetails.id,row.item.structureDetails.userName)" v-tooltip.hover="$t('res_Label_AssignUserChairman')" class="custom-table-icon">
														<span class="mdi mdi-account-tie" style="font-size: 20px"></span>
													</a>
												</div>

                                                <div class="custom-icon-wrapper structuresTableDeleteAction">
                                                    <v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="DeleteStructureUserGroup(row.item.structureDetails.id)">custom-icon white-bg delete-icon</v-icon>
                                                </div> 
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions" style="">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="addStructureUser = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editName" max-width="600px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_ButtonText_Edit") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="editName = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_NameEn") }} <span>*</span></label>
                                <v-text-field maxlength="150" v-model="selectedName" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label__NameAr") }} <span>*</span></label>
                                <v-text-field maxlength="150" v-model="selectedNameAr" label="" solo></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="editName = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" variant="text" @click="saveEditChanges">
                        {{ $t("res_ButtonText_Continue") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_ButtonText_New") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_NameEn") }}*</label>
                                <v-text-field maxlength="150" v-model="name" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label__NameAr") }}*</label>
                                <v-text-field maxlength="150" v-model="nameAr" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <div class="with-absolute-button">
                                    <v-radio-group v-model="type">
                                        <v-row no-gutters>
                                            <v-col cols="3"> 
                                                <v-radio :off-icon="type == 0 ? '$radioOn' : '$radioOff'" :label="IsInternallbl" value="1"></v-radio>
                                            </v-col>
                                            <v-col cols="3"> 
                                                <v-radio :label="IsExternallbl" value="2"></v-radio>
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="dialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" variant="text" @click="saveEntityGroup(name, nameAr, type)">
                        {{ $t("res_ButtonText_Continue") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as utils from "@/assets/js/common.js";
import StructureUserSelector from "@/components/StructureUserSelector.vue"; 
import constants from "@/assets/js/constants.js";
import axios from "axios";
import router from "@/router/index.js";
import Pagination from "@/components/Pagination.vue";

export default {
	name: "ManageCommittees",
	components: { StructureUserSelector, Pagination },
	data: function () {
		return {
			pagingData: {
				pageSize: 10,
				pageIndex: 0,
				totalCount: 0,
			},
			enableCommitteesChairmanUsers: false,
			totalRows: 0,
			GroupExternal: true,
			structs_users_items: [],
			IsExternallbl: this.$t("res_Label_IsExternal"),
			IsInternallbl: this.$t("res_Label_IsInternal"),
			searchTerm: "",
			searchTermlbl: this.$t("res_Label_SearchforCommittees"),
			searchName: "",
			entityGroupData: [],
			selectedNameAr: "",
			selectedName: "",
			editName: false,
			editedItem: {},
			selectedStructureId: null,
			selectedEntityGroupId: null,
			selectedUserId: -1,
			structureUserGroups: [],
			selectedEntity: [],
			addStructureUser: false,
			structureDialog: false,
			selectedStructures: [],
			structureUserGroups: null,
			alert: false, 
			alertMessage: "",
			alertColor: "",
			radioitems: {
				type: 0,
			},
			selectedRadios: "External",
			dialog: false,
			filterByName: "",
			selected: [],
			headers: [
				{ text: this.$t("res_GridHeaders_EnValue"), value: "name" },
				{ text: this.$t("res_GridHeaders_ArValue"), value: "nameAr" },
				{ text: this.$t("res_Label_TemplateType"), value: "type" },
				{ value: "actions", sortable: false },
			],
			structures_Users_Headers: [
				{
					text: this.$t("res_Label_User-Structure"),
					class: "text-center",
					sortable: false,
				},
				{
					text: this.$t("res_GridHeaders_Type"),
					class: "text-center",
					sortable: false,
				},
			],
			names: [{ name: "", nameAr: "", type: 0 }],
			entityGroupData: [], // Renaming the data property
			name: "",
			nameAr: "",
			type: 0,
			id: 0,
			structureUserGroups: null,
		};
	},
	methods: {
		backToAdminPage() {
			router.push({ name: "admin" });
		},
		clearFilter() {
			this.searchTerm = "";
			this.getEntityGroup();
		},
		openCommitteeForm()
		{  
			this.name = '';
			this.nameAr = '';
			this.type = 0;
			this.dialog = true;
		},
		getEntityGroup() {
			axios
				.get(
					constants.baseApiUrl +
						`StructureUser/GetAllEntityGroupsWithStructureUserGroups?searchTerm=${this.searchTerm.trim()}&PageNumber=${
							this.pagingData.pageIndex
						}&PageSize=${this.pagingData.pageSize}`
				)
				.then((res) => {
					if (
						res != null &&
						res != undefined &&
						res.data != "" &&
						res.data != null
					) {
						this.totalRows = res.data.total;
						this.pagingData.totalCount = res.data.total;
					} else {
						this.totalRows = 0;
						this.pagingData.totalCount = 0;
					}
					this.entityGroupData = res.data.records;
				})
				.catch((err) => console.warn(err));
		},
		structuresForEntityGroup(entityGroupId) {
			const entityGroup = this.entityGroupData.find(
				(e) => e.baseDetails.id === entityGroupId
			);
			if (entityGroup) {
				return entityGroup.structureUserGroups.map(
					(structureUserGroup) => {
						return {
							...structureUserGroup,
							name: structureUserGroup.name,
						};
					}
				);
			} else return [];
		},
		getEntityGroup: function () {
			axios
				.get(
					constants.baseApiUrl +
						`StructureUser/GetAllEntityGroupsWithStructureUserGroups?searchTerm=${this.searchTerm.trim()}&PageNumber=${
							this.pagingData.pageIndex
						}&PageSize=${this.pagingData.pageSize}`
				)
				.then((res) => {
					if (
						res != null &&
						res != undefined &&
						res.data != "" &&
						res.data != null
					) {
						this.totalRows = res.data.total;
						this.pagingData.totalCount = res.data.total;
					} else {
						this.totalRows = 0;
						this.pagingData.totalCount = 0;
					}
					 
					this.entityGroupData = res.data.records.map((entity) => {
						return {
							baseDetails: {
								id: entity.id,
								name: entity.name,
								nameAr: entity.nameAr,
								type: entity.type,
							},
							structureUserGroups:
								entity.structureUserGroups == null
									? []
									: entity.structureUserGroups.map(
											(structureUserGroup) => {
												return {
													structureDetails: {
														id: structureUserGroup.id,
														entityGroupId: structureUserGroup.entityGroupId,
														structureId: structureUserGroup.structureId,
														userId: structureUserGroup.userId,
														createdDate: structureUserGroup.createdDate,
														modifiedDate: structureUserGroup.modifiedDate,
														structureName: structureUserGroup.structureName,
														userName: structureUserGroup.userName,
														isUser: structureUserGroup.isUser,
														isChairman: structureUserGroup.isChairman,
													},
												};
											}
									  ) || [],
						};
					});
				})
				.catch((err) => console.warn(err));
		},
		getstruct() {
			axios
				.get(
					constants.baseApiUrl +
						"StructureUser/GetAllEntityGroupsWithStructureUserGroups"
				)
				.then((res) => {
					this.entityGroupData = res.data;
				})
				.catch((err) => console.warn(err));
		},
		structuresForEntityGroup(entityGroupId) { 
			const entityGroup = this.entityGroupData.find(
				(e) => e.baseDetails.id === entityGroupId
			);
			return entityGroup ? entityGroup.structureUserGroups : [];
		},
		UpdateUserChairman(id,userName) {  
			userName = !userName || userName == '' ? 'user' : userName;  
			  window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Label_AssignUserChairmanConfirmMessage', { userName }) ,
                    () => {
                       
				 axios
				.post(
					`${constants.baseApiUrl}StructureUser/AssignStructureUserGroupAsChairman?id=${id}`
				)
				.then((response) => { 
					if (response && response.data && response.data.success && response.data.id > 0) {
						this.$nextTick(() => {
							let ListToremoveisChairman = this.structs_users_items.filter(s=> s.structureDetails.id != id && s.structureDetails.isUser);
							if(ListToremoveisChairman != null && ListToremoveisChairman.length > 0)
							{
								for(let i=0; i < ListToremoveisChairman.length ; i++)
								{
									ListToremoveisChairman[i].structureDetails.isChairman = false;
								}
							} 
							let chairmanItem = this.structs_users_items.find(s=> s.structureDetails.id == id); 
							if(chairmanItem != null) { chairmanItem.structureDetails.isChairman = true; }
						});  
							window.showAlert(this.$t('res_Label_AssignUserChairmanSuccess', { userName }), "success") 
					 
					} 
				})
				.catch((error) => {
					console.error("Error:", error);
				});

                    },
                    () => {});
		},
		showStructureDilog(item) { 
			this.GroupExternal = item.baseDetails.type == 2;  
			this.selectedEntityGroupId = item.baseDetails.id;
			this.structs_users_items = this.structuresForEntityGroup(
				this.selectedEntityGroupId
			);
			this.addStructureUser = true;
		},
		saveEditChanges() {
			if(this.selectedName.trim() == '' || this.selectedNameAr.trim() == '')
			{
				window.showAlert(this.$t('res_Msgs_FillRequired'), "warning");
				return;
			}
			let updatedItem = {
				id: this.selectedEntityGroupId,
				name: this.selectedName,
				nameAr: this.selectedNameAr,
			};

			this.updateEntityGroupName(updatedItem);
			this.editName = false;
		},
		showEditDialog(item) {
			this.editName = true;
			this.selectedEntityGroupId = item.baseDetails.id;
			this.structs_users_items = this.structuresForEntityGroup(
				this.selectedEntityGroupId
			);
			this.selectedName = item.baseDetails.name;
			this.selectedNameAr = item.baseDetails.nameAr;
		},
		saveChanges() {
			this.selectedStructures.forEach((structureUser) => { 
				this.addStructureToGroup(
					typeof structureUser.id == "undefined" || structureUser.id.includes("-") ? null : structureUser.id, 
					this.selectedEntityGroupId,
					typeof structureUser.id != "undefined" && structureUser.id.includes("-") ? structureUser.id : null,
					structureUser.name
				);
			});
			this.selectedStructures = []
		},
		async doesCommitteHaveAnActiveWorkflow(committeeName)
		{
			try {
				const response = await axios.get(
					constants.baseApiUrl +
						`StructureUser/DoesCommitteeHaveAnActiveWorkFlow?commiteName=${committeeName}`
				);
				return response.data;
			} catch (error) {
				console.log(error);
			}
		},
		async updateEntityGroupName(item) 
		{
			axios.post(
					`${constants.baseApiUrl}StructureUser/EditEntityGroupName`,
					{ id: item.id, name: item.name, nameAr: item.nameAr },
					{
						params: { entityId: item.id },
					}
				)
				.then((res) => 
				{
					this.getEntityGroup();
				})
				.catch((err) => console.warn(err));
		},
		async deleteEntityGroup(item) {
			const hasActiveWorkflow = await this.doesCommitteHaveAnActiveWorkflow(item.baseDetails.name);
			if(hasActiveWorkflow)
			{
				window.showAlert(this.$t('res_Msgs_CommitteeWorkflow'), "error");
				return;
			}
			window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_DeleteCommitteeConfirmation"),
                () => 
					{
						this.selectedEntityGroupId = item.baseDetails.id;
						axios
							.post(
								`${constants.baseApiUrl}StructureUser/DeleteEntityGroup?entityId=` +
									this.selectedEntityGroupId
							)
							.then((res) => {
								this.getEntityGroup();
							})
							.catch((err) => console.warn(err));
                	},
                () => { });
		},
		updateSelectedStructures(newStructures) { 
			this.selectedStructures = newStructures;
			this.matchSelectedStructures();
		},
		matchSelectedStructures() {
			this.selectedStructures.forEach((selectedStructure) => {
				this.entityGroupData.forEach((entity) => {
					entity.structureUserGroups.forEach((structureUserGroup) => {
						if (structureUserGroup.id === selectedStructure.id) {
							console.log("Match found:", selectedStructure);
						}
					});
				});
			});
		},
		DeleteStructureUserGroup(id) { 
			window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_DeleteComitteUserConfirmation"),
				() => 
					{
						axios
							.delete(
								constants.baseApiUrl +
									`StructureUser/DeleteStructureUserGroup?id=${id}`
							)
							.then((res) => {
								this.structs_users_items = this.structs_users_items.filter(
									(s) => s.structureDetails.id != id
								);
								this.entityGroupData.find((e) => e.baseDetails.id === this.selectedEntityGroupId).structureUserGroups
								= 
								this.entityGroupData.find((e) => e.baseDetails.id === this.selectedEntityGroupId).structureUserGroups.filter(
									(s) => s.structureDetails.id != id
								);
							})
							.catch((err) => console.warn(err));
					},
				() => { });
		},
		addStructureToGroup(structureId, entityGroupId, userId, name) 
		{ 
			if (structureId == null && userId == null)
				return false;

			let structureIdForUserId = userId == null || !userId.includes('-') ? null : userId.split('-')[1];
			userId = userId == null || !userId.includes('-') ? null : userId.split('-')[0];

			axios.post(`${constants.baseApiUrl}StructureUser/AddStructureUserGroup`,
					{
						structureId: structureId == null || structureId <= 0 ? structureIdForUserId : structureId,
						entityGroupId: entityGroupId,
						userId: userId,
					}
				)
				.then((response) => { 
					if (response && response.data && response.data.id > 0) {
						this.$nextTick(() => {
							this.structs_users_items.push({
								structureDetails: {
									id: response.data.id,
									userName: userId > 0 ? name : "",
									structureName: structureId > 0 ? name : "",
									userId: userId,
									structureId: structureId,
									isUser:userId > 0,
									isChairman: false,
								},
							});
						});

						window.showAlert("The entity group was added successfully.","success");
					} 
				})
				.catch((error) => {
					console.error("Error:", error);
				});
		},
		async addEntityGroup(name, nameAr, type) {
			try {
				const response = await axios.post(
					`${constants.baseApiUrl}StructureUser/CreateEntityGroup`,
					{
						name: name.trim(),
						nameAr: nameAr.trim(),
						type: type,
					}
				);

				console.log("Success:", response);
				return response;
			} catch (error) {
				console.error("Error:", error);
				throw error;
			}
		},
		async saveEntityGroup(name, nameAr, type) { 
			if(name.trim() == '' || nameAr.trim() == '' || name == null || nameAr == null)
			{ 
				window.showAlert( this.$t("res_Msgs_FillRequired"), "warning");
				return;
			} 
			try {
				await this.addEntityGroup(name, nameAr, type);

				this.dialog = false;
				this.alertMessage = "Saved";
				this.alertColor = "green";
				this.alert = true;

				await this.getEntityGroup();
			} 
			catch (error) {
				this.alertMessage = "An error occurred. Please try again.";
				this.alertColor = "red";
				this.alert = true;
			}
		},
		pageIndexChanged(pagingData) {
			this.pagingData.pageSize = pagingData.pageSize;
			this.pagingData.pageIndex = pagingData.pageIndex;
			this.getEntityGroup();
		},
	},
	computed: {
		filteredNames() {
			return this.names.filter((eachname) => {
				return eachname.name
					.toLowerCase()
					.includes(this.filterByName.toLowerCase());
			});
		},
		translatedType() {
			return this.radioitems.Type === "1" ? "Internal" : "External";
		},
	},
	mounted() {
		this.getEntityGroup();
		this.enableCommitteesChairmanUsers = window.enableCommitteesChairmanUsers;  
		if(this.enableCommitteesChairmanUsers == true){this.structures_Users_Headers.push({ text: this.$t("res_Label_IsChairman"), class: "text-center", sortable: false});}
		 this.structures_Users_Headers.push({ text: "", value: "actions", sortable: false });
	},
};
</script>

<style>

#ManageCommitteeUserStructureSelector button
{
	display: none !important;
}

.CommitteesActionstd .custom-icon-wrapper {
    margin: 0px 4px;
}
.CommitteesTable thead th span {
    justify-content: center !important;
}

.custom-table-icon {
    padding: 14px 9px 8px 9px;
    border-radius: 6px;
}

.custom-table-icon span {
    color: #959fb4 !important;
}

.custom-table-icon:hover {
    background-color: #e4ebfb;
}

.custom-table-icon:hover span {
    color: #4577e5 !important;
}

#structuresTable thead th span {
    justify-content: center !important;
}
#structuresTable {
    max-height: 350px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
<style scoped>
.v-data-table-header th {
    background-color: #e7ebef;
}
.multiselect__tag-icon {
    display: none !important;
}
.v-icon.notranslate.v-data-table-header__icon {
    display: none !important;
}

.vtooltip {
    background-color: white;
    padding: 5px;
    border-radius: 25px;
}
.report-container .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.report_header {
    height: 50px;
    vertical-align: middle;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.015em;
    color: #667593;
}

.report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,
.report-container .v-data-table__wrapper table thead {
    background-color: #fff;
    box-shadow: none;
}

.report-container {
    height: calc(100vh - 116px);
    display: flex;
    flex-direction: column;
    border-radius: 12px !important;
    overflow: auto;
    box-shadow: none !important;
}

.report-container .border-top {
    display: flex;
    flex-direction: column;
}

.report-container .v-toolbar {
    height: 80px !important;
    padding: 0;
}
.report-container .v-toolbar__content {
    height: 100% !important;
    padding: 24px !important;
}
img#ItemPreview {
    width: 100px;
    margin: 0.5rem 0;
}
.mdi-menu-down {
    filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
}
.v-dialog .v-toolbar__content {
    height: 100% !important;
}
</style>
